import { jsx as _jsx } from "react/jsx-runtime";
import { FHIRSandboxRequestComposer } from './FHIRSandboxRequestComposer/index.js';
import { FHIRSandboxRequestHistory } from './FHIRSandboxRequestHistory/index.js';
import { workspaceKey_AdvisorSandboxEpic } from '../../workspace-configs.js';
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend';
import { Page_BaseSandbox } from '../Page_BaseSandbox/Page_BaseSandbox.js';
import { ModuleFE_ActiveUser } from '../../../_entity/advisor-session/ModuleFE_ActiveUser.js';
import { FHIRSandboxRequestTemplates } from './FHIRSandboxRequestTemplates/index.js';
const EditorKey_SandboxFHIREpic = 'sandbox-fhir-epic';
export class Page_SandboxFHIR extends Page_BaseSandbox {
    static Route = {
        key: 'fhir-sandbox',
        path: 'fhir-sandbox',
        Component: this,
    };
    workspace = () => ({
        id: EditorKey_SandboxFHIREpic,
        key: workspaceKey_AdvisorSandboxEpic,
        instances: {},
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
            templates: () => _jsx(FHIRSandboxRequestTemplates, {}),
            composer: () => _jsx(FHIRSandboxRequestComposer, {}),
            history: () => _jsx(FHIRSandboxRequestHistory, {}),
        }
    });
    getHeader() {
        return 'FHIR Sandbox';
    }
    componentDidMount() {
        ModuleFE_ActiveUser.sandbox.onOpen();
    }
    componentWillUnmount() {
        ModuleFE_ActiveUser.sandbox.onClose();
    }
}
//# sourceMappingURL=Page_SandboxFHIR.js.map